export default {
  title: 'Aggiornamenti',
  fields: {
    app_version: 'Versione app',
    description: 'Descrizione',
    created_at: 'Creato il',
  },
};
